import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import {TerminalMaster} from "./TerminalMaster";

const TerminalManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url }
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <TerminalMaster />} /> 
  </Switch>
);

export const TerminalManagement = withRouter(TerminalManagementRoutes);
